import { BASE_URL } from "../../data/BaseUrl";

export const fetchPtProspectsStats = async (filters, TOKEN) => {
  let url = `leads/pt-prospect/stats`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchPtProspectsStats=> ", error);
    throw error;
  }
};

export const fetchPtProspects = async (filters, TOKEN) => {
  let url = `leads/pt-prospect`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchPtProspects=> ", error);
    throw error;
  }
};

export const fetchFDDFPaymentCreation = async (filters, TOKEN) => {
  let url = `payment/dp_toggle`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchFDDFPaymentCreation=> ", error);
    throw error;
  }
};

export const fetchDiscountPaymentCreation = async (filters, TOKEN) => {
  let url = `payment/discount_req_limit_toggle`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchDiscountPaymentCreation=> ", error);
    throw error;
  }
};

export const fetchFDDPaymentLinkAccess = async (user_id, filters, TOKEN) => {
  let url = `user/id/${user_id || ""}`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    if (responseJson?.status && responseJson?.data?.is_payment) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error("fetchFDDPaymentLinkAccess=> ", error);
    throw error;
  }
};

export const fetchReferralStat = async (filters, TOKEN) => {
  let url = `leads/referral/stats`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchReferralStat=> ", error);
    throw error;
  }
};

export const fetchReferrals = async (filters, TOKEN) => {
  let url = `leads/referral/all`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchReferrals=> ", error);
    throw error;
  }
};

export const fetchTMEApprovalManager = async (filters, TOKEN) => {
  let url = `member_engagement/approval_manager`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchTMEApprovalManager=> ", error);
    throw error;
  }
};

export const fetchAgentTargetStats = async (filters, TOKEN) => {
  let url = `staff/performance?is_stats=1`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `&${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchAgentTargetStats=> ", error);
    throw error;
  }
};

export const fetchAgentDailyTarget = async (filters, TOKEN) => {
  let url = `staff/performance`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchAgentDailyTarget=> ", error);
    throw error;
  }
};

export const fetchAgentWeeklyTarget = async (filters, TOKEN) => {
  let url = `staff/performance/stats`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchAgentWeeklyTarget=> ", error);
    throw error;
  }
};

export const fetchCheckedInMembers = async (filters, TOKEN) => {
  let url = `member_engagement/active_user`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchCheckedInMembers=> ", error);
    throw error;
  }
};

export const fetchBTLVendors = async (filters, TOKEN) => {
  let url = `leads/btl/vendor`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchBTLVendors=> ", error);
    throw error;
  }
};

export const fetchBTLLeads = async (filters, TOKEN) => {
  let url = `leads/btl`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchBTLLeads=> ", error);
    throw error;
  }
};

export const fetchStaffOnboardingRequests = async (filters, TOKEN) => {
  let url = `staff`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchStaffOnboardingRequests=> ", error);
    throw error;
  }
};

export const fetchDeletedStaff = async (filters, TOKEN) => {
  let url = `staff?status=deleted`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `&${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchDeletedStaff=> ", error);
    throw error;
  }
};

export const fetchStaffOffboarding = async (filters, TOKEN) => {
  let url = `staff-offboarding`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchStaffOffboarding=> ", error);
    throw error;
  }
};

export const markStaffOffboardingComplete = async (id, payload, TOKEN) => {
  try {
    const response = await fetch(`${BASE_URL}/staff-offboarding/update?id=${id}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("markStaffOffboardingComplete=> ", error);
    throw error;
  }
};

export const fetchReceptionists = async (filters, TOKEN) => {
  let url = `user/receptionist`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchReceptionists=> ", error);
    throw error;
  }
};

export const fetchGymKeywordStats = async (filters, TOKEN) => {
  let url = `leads/wati_auto_mapped_leads/stats`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchGymKeywordStats=> ", error);
    throw error;
  }
};

export const fetchGymKeywords = async (filters, TOKEN) => {
  let url = `wati/predefined_msg?auto_gym_map=1`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `&${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchGymKeywords=> ", error);
    throw error;
  }
};

export const fetchCashReports = async (filters, TOKEN) => {
  let url = `payment/cash_validation_log`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchCashReports=> ", error);
    throw error;
  }
};

export const fetchWalkinLeads = async (filters, TOKEN) => {
  let url = `leads/walkin`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchWalkinLeads=> ", error);
    throw error;
  }
};

export const fetchFitnessProfileLogs = async (filters, TOKEN) => {
  let url = `member/fitness_profiles_logs`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchFitnessProfileLogs=> ", error);
    throw error;
  }
};

export const fetchFitnessProfileStats = async (filters, TOKEN) => {
  let url = `member/fitness_profiles_logs/stats`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchFitnessProfileStats=> ", error);
    throw error;
  }
};

export const fetchBCALogs = async (filters, TOKEN) => {
  let url = `member/fitness_profiles/bca_logs`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchBCALogs=> ", error);
    throw error;
  }
};

export const fetchBCAStats = async (filters, TOKEN) => {
  let url = `member/fitness_profiles/bca_logs/stats`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchBCAStats=> ", error);
    throw error;
  }
};

export const fetchWaitGymwise = async (filters, TOKEN) => {
  let url = `leads/wati/stats/gymwise`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchWaitGymwise=> ", error);
    throw error;
  }
};

export const fetchLeadTimeline = async (filters, TOKEN) => {
  let url = `leads/timeline`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchLeadTimeline=> ", error);
    throw error;
  }
};

export const fetchLeadCycle = async (filters, TOKEN) => {
  let url = `leads/cycle`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchLeadCycle=> ", error);
    throw error;
  }
};

export const fetchLMSFollowups = async (filters, TOKEN) => {
  let url = `leads/follow-up/v2`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchLMSFollowups=> ", error);
    throw error;
  }
};

export const fetchFreshLeads = async (filters, TOKEN) => {
  let url = `leads/fresh`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchFreshLeads=> ", error);
    throw error;
  }
};

export const fetchStaffProfiles = async (filters, TOKEN) => {
  let url = `user/staff-profile-approval`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchStaffProfiles=> ", error);
    throw error;
  }
};
export const fetchClosureExpectedStats = async (filters, token) => {
  let url = `leads/clousre-expected-stats`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchClosureExpectedStats=> ", error);
    throw error;
  }
};

export const fetchRedFlags = async (filters, token) => {
  let url = `leads/red-flags`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchRedFlags=> ", error);
    throw error;
  }
};

export const fetchVisitSuccessMetrics = async (filters, token) => {
  let url = `leads/visit-success-metrics`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchVisitSuccessMetrics=> ", error);
    throw error;
  }
};

export const fetchRecentGymActivity = async (filters, token) => {
  let url = `leads/recent-gym-activity`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchRecentGymActivity=> ", error);
    throw error;
  }
};

export const fetchPipelineStats = async (filters, token) => {
  let url = `leads/pipeline-stats`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchPipelineStats=> ", error);
    throw error;
  }
};

export const fetchClosurePipelineCriticalTracking = async (filters, token) => {
  let url = `leads/closure-pipeline-critical-tracking`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchClosurePipelineCriticalTracking=> ", error);
    throw error;
  }
};

export const fetchClosurePipelineCriticalTrackingOverview = async (
  filters,
  token
) => {
  let url = `leads/closure-pipeline-critical-tracking-overview`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchClosurePipelineCriticalTrackingOverview=> ", error);
    throw error;
  }
};

export const fetchClosureExpectedDeepTracker = async (filters, token) => {
  let url = `leads/closure-expected-deep-tracker`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchClosureExpectedDeepTracker=> ", error);
    throw error;
  }
};

export const fetchDeepTrackerTimelineView = async (filters, token) => {
  let url = `leads/deep-tracker-timeline-view`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchDeepTrackerTimelineView=> ", error);
    throw error;
  }
};

export const fetchClosurePatternAnalysis = async (filters, token) => {
  let url = `leads/closure-pattern-analysis`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchClosurePatternAnalysis=> ", error);
    throw error;
  }
};

export const fetchDailyLeadMovementStats = async (filters, token) => {
  let url = `leads/daily-lead-movement-stats`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchDailyLeadMovementStats=> ", error);
    throw error;
  }
};

// Agent Management
export const fetchAgentManagement = async (filters, token) => {
  let url = `leads/agent-management`;

  const filteredParams = Object.entries(filters || {})
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAgentManagement=> ", error);
    throw error;
  }
};

export const fetchAcademyLeads = async (filters, TOKEN) => {
  let url = `academy/leads`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAcademyLeads=> ", error);
    throw error;
  }
};

export const fetchStaffAttendanceStats = async (filters, TOKEN) => {
  let url = `staff/attandance/stats`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchStaffAttendanceStats=> ", error);
    throw error;
  }
};

export const fetchMemberCheckinMetrics = async (filters, TOKEN) => {
  let url = `gym/dashboard-metrics`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchMemberCheckinMetrics=> ", error);
    throw error;
  }
};

export const fetchGymwiseCheckinMetrics = async (filters, TOKEN) => {
  let url = `gym/gym-metrics`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchGymwiseCheckinMetrics=> ", error);
    throw error;
  }
};

export const fetchGymCardStats = async (filters, TOKEN) => {
  let url = `gym/dashboard/card-stats`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchGymCardStats=> ", error);
    throw error;
  }
};

export const fetchGymDistributionStats = async (filters, TOKEN) => {
  let url = `gym/distribution-stats`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchGymDistributionStats=> ", error);
    throw error;
  }
};

export const fetchGymSegmentMembers = async (filters, TOKEN) => {
  let url = `gym/segment_members`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchGymSegmentMembers=> ", error);
    throw error;
  }
};

export const fetchFreshLeadsV2 = async (filters, TOKEN) => {
  let url = `leads/v2`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchFreshLeadsV2=> ", error);
    throw error;
  }
};

export const fetchRegularizationRequest = async (filters, TOKEN) => {
  let url = `attandance/regularization`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchRegularizationRequest=> ", error);
    throw error;
  }
};

export const fetchTMEGymwiseAnalysis = async (filters, TOKEN) => {
  let url = `trainerandmember/stats-by-gym`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTMEGymwiseAnalysis=> ", error);
    throw error;
  }
};

export const fetchTMECheckinAnalysis = async (filters, TOKEN) => {
  let url = `member_engagement/checkin_timeline/stats`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTMECheckinAnalysis=> ", error);
    throw error;
  }
};

export const fetchTMECheckinBreakdown = async (filters, TOKEN) => {
  let url = `member_engagement/checkin_breakdown_stats`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTMECheckinBreakdown=> ", error);
    throw error;
  }
};

export const fetchTMECheckinTimeline = async (filters, TOKEN) => {
  let url = `member_engagement/checkin_timeline`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTMECheckinTimeline=> ", error);
    throw error;
  }
};

export const fetchExpiredMembers = async (filters, TOKEN) => {
  // let url = `trainer/expired_members`;
  let url = `trainer/trainer_report_members_details?user_type=expired`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchExpiredMembers=> ", error);
    throw error;
  }
};

export const fetchGymRetentionStats = async (filters, TOKEN) => {
  let url = `trainer/gym_retention_stats`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchGymRetentionStats=> ", error);
    throw error;
  }
};

export const fetchMemberWeight = async (filters, TOKEN) => {
  let url = `member/weight`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchMemberWeight=> ", error);
    throw error;
  }
};

export const fetchBMIChart = async (filters, TOKEN) => {
  let url = `member/bmi/logs`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchBMIChart=> ", error);
    throw error;
  }
};

export const fetchHealthTracking = async (filters, TOKEN) => {
  let url = `user/health-tracking`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchHealthTracking=> ", error);
    throw error;
  }
};

export const fetchWTF360Consultations = async (filters, TOKEN) => {
  let url = `wtf360/consultation/all`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchWTF360Consultations=> ", error);
    throw error;
  }
};

export const fetchDiscountApprovalAccess = async (filters, TOKEN) => {
  let url = `user/notification-directory?discount_approval_access=1`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `&${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchDiscountApprovalAccess=> ", error);
    throw error;
  }
};

export const fetchCallLogs = async (filters, TOKEN) => {
  let url = `leads/call_details`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchCallLogs=> ", error);
    throw error;
  }
};

export const fetchTrainerStats = async (filters, TOKEN) => {
  let url = `trainer/trainer_stats`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTrainerStats=> ", error);
    throw error;
  }
};

export const fetchTrainerStatsDetails = async (filters, TOKEN) => {
  let url = `trainer/trainer_stats_details`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTrainerStatsDetails=> ", error);
    throw error;
  }
};

export const fetchWTF360Inquiry = async (filters, TOKEN) => {
  let url = `wtf-main/inquiry`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchWTF360Inquiry=> ", error);
    throw error;
  }
};

export const fetchPreSaleGymLeads = async (filters, TOKEN) => {
  let url = `presale`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchPreSaleGymLeads=> ", error);
    throw error;
  }
};
